import { Skeleton, Stack } from '@mui/material'

import { useOrderStepTrackingLink } from '../../../../../../orderNotificationAtom'

import { TrackingLink } from './components/TrackingLink'
import { TrackingLinkFailed } from './components/TrackingLinkFailed'

type Props = {
  extendedOrderId: string
  status: 'loading' | 'failed' | 'ready'
}

export function OrderStepTrackingLink(props: Props) {
  const { extendedOrderId, status } = props

  const trackingLink = useOrderStepTrackingLink(extendedOrderId)

  if (status === 'loading') {
    return (
      <Stack direction="column">
        <Skeleton variant="rectangular" height={16} width="30%" />
        <Skeleton variant="rectangular" height={40} width="100%" sx={{ mt: '12px' }} />
      </Stack>
    )
  }

  if (status === 'failed') {
    return <TrackingLinkFailed />
  }

  if (!trackingLink) return null

  return <TrackingLink link={trackingLink} />
}
